import { OnInit, Injector } from '@angular/core';
import { EventsService } from '../../core/services/events-service/events.service';
import { ControlValueAccessor, NgControl, } from '@angular/forms';
import { tap } from 'rxjs/operators';
var EventImageUploadComponent = /** @class */ (function () {
    function EventImageUploadComponent(eventService, injector) {
        this.eventService = eventService;
        this.injector = injector;
        this.eventId = '';
        this.showValidation = false;
        this.buttonLabel = 'Upload Image';
        this.uploadType = 'image';
        this.acceptableFiles = 'image/jpeg, image/png, application/pdf';
        this.imageId = '';
        this.success = false;
        this.uploading = false;
        this.uploadError = false;
    }
    Object.defineProperty(EventImageUploadComponent.prototype, "isControlInvalid", {
        get: function () {
            if (this.ngControl) {
                return this.ngControl.invalid;
            }
            return false;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EventImageUploadComponent.prototype, "buttonContext", {
        get: function () {
            if (this.isControlInvalid && this.showValidation) {
                return 'danger';
            }
            return 'primary';
        },
        enumerable: true,
        configurable: true
    });
    EventImageUploadComponent.prototype.ngOnInit = function () {
        this.ngControl = this.injector.get(NgControl);
    };
    EventImageUploadComponent.prototype.onFileChange = function (event) {
        this.uploadError = false;
        if (event.target.files && event.target.files.length > 0) {
            var file = event.target.files[0];
            this.uploadFile(file);
        }
    };
    EventImageUploadComponent.prototype.uploadFile = function (file) {
        var _this = this;
        var observable;
        this.uploading = true;
        this.success = false;
        if (this.uploadType === 'document') {
            var formData = new FormData();
            formData.append('document', file, file.name);
            observable = this.eventService.postRegistrationDocument(this.eventId, formData);
        }
        else {
            var formData = new FormData();
            formData.append('image', file, file.name);
            observable = this.eventService.postRegistrationImage(this.eventId, formData);
        }
        observable
            .pipe(tap(function () { return (_this.uploading = false); }, function () { return (_this.uploading = false); }))
            .subscribe(function (event) {
            _this.setImageId(event.id);
            _this.showPreview(file);
            _this.success = true;
        }, function (err) {
            _this.uploadError = true;
        });
    };
    EventImageUploadComponent.prototype.showPreview = function (file) {
        var _this = this;
        if (this.uploadType !== 'image') {
            return;
        }
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            _this.imgSrc = reader.result;
        };
    };
    EventImageUploadComponent.prototype.setImageId = function (id) {
        this.imageId = id;
        if (this.onChange) {
            this.onChange(id);
        }
    };
    EventImageUploadComponent.prototype.writeValue = function (value) {
        this.imageId = value;
    };
    EventImageUploadComponent.prototype.registerOnChange = function (fn) {
        this.onChange = fn;
    };
    EventImageUploadComponent.prototype.registerOnTouched = function (fn) {
        this.onTouched = fn;
    };
    return EventImageUploadComponent;
}());
export { EventImageUploadComponent };
